import comp from "./ModalContainer";
export default comp;
